import React, { useEffect } from 'react';
import { Route } from 'react-router-dom';
import { LinearProgress } from '@mui/material';
import { NavBarContent } from 'feature/nav/NavBar';
import DocumentTabs from '../DocumentTabs';
import useStyles from './Document.styles';
import useRetrieveData from 'global/hooks/useRetrieveData';
import { useShowChanges } from 'global/hooks/useShowChanges';
import { first, get } from 'global/lib/lodash';
import { Transform, Includes } from '../DocumentList';
import DiffViewer from 'global/components/diff-text';
import withDocumentParent from './withDocumentParent';

export default function Document(props) {
  const { match } = props;
  const classes = useStyles();
  const { showChangesOn } = useShowChanges();

  const edition_id = get(props, 'editionId', get(match, 'params.library'));
  const classification_id = get(props, 'classificationId', get(match, 'params.document'));
  const edition = useRetrieveData({ url: `/editions/${edition_id}` }, { build: ['editions'], params: { include: 'scorecards,scorecards.checklists' }, transformData: (d) => first(d) });

  const { data, loading, update } = useRetrieveData(
    { url: `/edition-documents` },
    {
      useLangFilter: true,
      build: ['editionDocuments'],
      params: {
        include: Includes.join(','),
        filter: { classification_id, edition_id },
        editMode: 1,
      },
      useEffect: true,
      transformData: Transform,
    }
  );
  
  useEffect(() => {
    update();
  }, [classification_id]);
  
  return <_Document {...props} doc={data} {...{data, edition, edition_id, showChangesOn, classes, loading, update }} />
}

const _Document = withDocumentParent((props) => {
  const { data, edition_id, edition, editionParent, showChangesOn, parentDocument, documentParentId, classes, loading, update } = props;
  
  const showChanges = showChangesOn && !!documentParentId && !parentDocument.loading;
  const diffElement = showChanges ? <DiffViewer oldText={get(parentDocument, 'data.name')} newText={get(data, '0.document.name')} diffType="words" /> : get(data, '0.document.name');

  return (
    <div className={classes.content}>
      <NavBarContent pageTitle={loading ? 'Loading...' : diffElement} link={'library/' + edition_id} closeProps={props.closeProps} />
      <Route
        exact
        path={`/library/:library/document/:document`}
        render={(p) => (
          <DocumentTabs
            {...p}
            edition={edition.data}
            editionParent={editionParent.data}
            documents={data}
            parentDocument={parentDocument}
            documentParentId={documentParentId}
            update={update}
            userCanEdit={get(edition, 'data.userCanEdit', false)}
          />
        )}
      />
      {props.isModal && (
        <DocumentTabs
          {...props}
          documents={data}
          edition={edition.data}
          editionParent={editionParent.data}
          update={update}
          canEdit={get(edition, 'data.userCanEdit', false)}
        />
      )}
      {loading && <LinearProgress />}
    </div>
  );
});
